import { useQuery } from '@tanstack/react-query'
import { useSelector } from 'react-redux'
import { getCompanyGroupOptions } from './getCompanyGroupOptions'
import { contextCompanyIdSelector } from '../../../redux/context/company/selectors'

export const useSubsidiaries = (companyId: string) => {
  return useQuery({
    ...getCompanyGroupOptions(companyId, data => data.subsidiaries ?? []),
    enabled: !!companyId
  })
}

export const useCtxSubsidiaries = () => {
  const companyId = useSelector(contextCompanyIdSelector)!
  return useSubsidiaries(companyId)
}
